angular.module('clientDashboardApp').factory('customProvidersService', function ($http) {
  const get = () => $http.get('/v5/contentProviders')

  // Used to populate select lists of providers
  // Do not use for editing custom providers, will make it confusing to update since providers are all one resource
  const getContentProvidersWithChildAccounts = () => $http.get('/v5/contentProvidersWithChildAccounts')

  const update = (contentProviders) => $http.post('/v5/contentProviders', { contentProviders })

  return { get, getContentProvidersWithChildAccounts, update }
})
